var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size}},[(_vm.photoSizeUrl)?_c('v-img',{attrs:{"aspect-ratio":1,"src":_vm.photoSizeUrl},on:{"error":function($event){_vm.imgError = true}}}):_c('div',[_c('v-icon',{attrs:{"small":""},domProps:{"textContent":_vm._s('$userCircle')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }